import { useMessageFormatter } from "@react-aria/i18n";
import { useCallback, useEffect, useRef } from "react";
import { announce } from "@react-aria/live-announcer";
import _babelRuntimeHelpersEsmInteropRequireDefault from "@babel/runtime/helpers/esm/interopRequireDefault"; // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/ar-AE.json

var $fbc9e9d7cb7b3e7c701c779ec38417cd$exports = {};
$fbc9e9d7cb7b3e7c701c779ec38417cd$exports = JSON.parse("{\"Empty\":\"فارغ\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/bg-BG.json

var $cb592d229837e637f9593ff7c701689$exports = {};
$cb592d229837e637f9593ff7c701689$exports = JSON.parse("{\"Empty\":\"Изпразни\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/cs-CZ.json

var $f17666a495bf7495c6bff6a1397e6822$exports = {};
$f17666a495bf7495c6bff6a1397e6822$exports = JSON.parse("{\"Empty\":\"Prázdné\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/da-DK.json

var $e194eb80ef0031d8117819166a22680$exports = {};
$e194eb80ef0031d8117819166a22680$exports = JSON.parse("{\"Empty\":\"Tom\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/de-DE.json

var $c40bcdf693a8ed8a2291ef8d7b$exports = {};
$c40bcdf693a8ed8a2291ef8d7b$exports = JSON.parse("{\"Empty\":\"Leer\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/el-GR.json

var $ac454f31f410e77efbde3e1e4851cedb$exports = {};
$ac454f31f410e77efbde3e1e4851cedb$exports = JSON.parse("{\"Empty\":\"Άδειο\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/en-US.json

var $ed19cb0446558aab98a9086a697ac7$exports = {};
$ed19cb0446558aab98a9086a697ac7$exports = JSON.parse("{\"Empty\":\"Empty\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/es-ES.json

var $dc8cdf38b1ab312b8e3dd3e35ac00a29$exports = {};
$dc8cdf38b1ab312b8e3dd3e35ac00a29$exports = JSON.parse("{\"Empty\":\"Vacío\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/et-EE.json

var $a694686b3766c14509e50fe827e0f2b$exports = {};
$a694686b3766c14509e50fe827e0f2b$exports = JSON.parse("{\"Empty\":\"Tühjenda\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/fi-FI.json

var $cb67d619f35171d4f8c8e2fc148491$exports = {};
$cb67d619f35171d4f8c8e2fc148491$exports = JSON.parse("{\"Empty\":\"Tyhjä\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/fr-FR.json

var $af684764dbb48d4f24251e7a5c48530$exports = {};
$af684764dbb48d4f24251e7a5c48530$exports = JSON.parse("{\"Empty\":\"Vide\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/he-IL.json

var $d69024b42a69f97c46c58a953f67e84f$exports = {};
$d69024b42a69f97c46c58a953f67e84f$exports = JSON.parse("{\"Empty\":\"ריק\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/hr-HR.json

var $e6b7076edc78920211046f3c983cfbdb$exports = {};
$e6b7076edc78920211046f3c983cfbdb$exports = JSON.parse("{\"Empty\":\"Prazno\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/hu-HU.json

var $db974e9c56980ee80c35253d2f136aee$exports = {};
$db974e9c56980ee80c35253d2f136aee$exports = JSON.parse("{\"Empty\":\"Üres\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/it-IT.json

var $b9ca32da5122499256c996b9183ca3d$exports = {};
$b9ca32da5122499256c996b9183ca3d$exports = JSON.parse("{\"Empty\":\"Vuoto\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/ja-JP.json

var $d93cbf7ca50d42ab95c8247bd7$exports = {};
$d93cbf7ca50d42ab95c8247bd7$exports = JSON.parse("{\"Empty\":\"空\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/ko-KR.json

var $e4194ee149df1a8d2d78edc886ab7fd$exports = {};
$e4194ee149df1a8d2d78edc886ab7fd$exports = JSON.parse("{\"Empty\":\"비어 있음\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/lt-LT.json

var $e084f50698524d1617f726c5c5229$exports = {};
$e084f50698524d1617f726c5c5229$exports = JSON.parse("{\"Empty\":\"Tuščias\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/lv-LV.json

var $d6d90ca120aa4d5001ed49fd45b8$exports = {};
$d6d90ca120aa4d5001ed49fd45b8$exports = JSON.parse("{\"Empty\":\"Tukšs\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/nb-NO.json

var $a3b3b03e00a7f050d1866c8c67b7f18c$exports = {};
$a3b3b03e00a7f050d1866c8c67b7f18c$exports = JSON.parse("{\"Empty\":\"Tom\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/nl-NL.json

var $b87ad28933ffd5d3c721324feb$exports = {};
$b87ad28933ffd5d3c721324feb$exports = JSON.parse("{\"Empty\":\"Leeg\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/pl-PL.json

var $f5481a4fa637113043217da5a6260$exports = {};
$f5481a4fa637113043217da5a6260$exports = JSON.parse("{\"Empty\":\"Pusty\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/pt-BR.json

var $fd14df6b825e4a9565037f1ca1aa0f0$exports = {};
$fd14df6b825e4a9565037f1ca1aa0f0$exports = JSON.parse("{\"Empty\":\"Vazio\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/pt-PT.json

var $c82d4c61928ba408ae61ffae1197cc$exports = {};
$c82d4c61928ba408ae61ffae1197cc$exports = JSON.parse("{\"Empty\":\"Vazio\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/ro-RO.json

var $f83fdc6074b3422b785a49bb04be8fd$exports = {};
$f83fdc6074b3422b785a49bb04be8fd$exports = JSON.parse("{\"Empty\":\"Gol\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/ru-RU.json

var $c0d7db44cf5646c580ef6639717353$exports = {};
$c0d7db44cf5646c580ef6639717353$exports = JSON.parse("{\"Empty\":\"Не заполнено\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/sk-SK.json

var $a780415d2ea29cc31052caf8538da8$exports = {};
$a780415d2ea29cc31052caf8538da8$exports = JSON.parse("{\"Empty\":\"Prázdne\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/sl-SI.json

var $fb01b3dc59b99eb11848f254d$exports = {};
$fb01b3dc59b99eb11848f254d$exports = JSON.parse("{\"Empty\":\"Prazen\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/sr-SP.json

var $e08a3987f61a6b3d12b3e19ec5fd9$exports = {};
$e08a3987f61a6b3d12b3e19ec5fd9$exports = JSON.parse("{\"Empty\":\"Prazno\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/sv-SE.json

var $b3a7572915c12bdc376a15c698e26a$exports = {};
$b3a7572915c12bdc376a15c698e26a$exports = JSON.parse("{\"Empty\":\"Tomt\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/tr-TR.json

var $fffe30e4880b8ca2a1bf8bd52f099e3$exports = {};
$fffe30e4880b8ca2a1bf8bd52f099e3$exports = JSON.parse("{\"Empty\":\"Boş\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/uk-UA.json

var $daa0babda3d97bfdac06e14540e3d556$exports = {};
$daa0babda3d97bfdac06e14540e3d556$exports = JSON.parse("{\"Empty\":\"Пусто\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/zh-CN.json

var $b9d579215c0cc839bfce28a9cec$exports = {};
$b9d579215c0cc839bfce28a9cec$exports = JSON.parse("{\"Empty\":\"空\"}"); // ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/spinbutton/intl/zh-TW.json

var $fcd9e4d86a0277eaf944ca3546ee7$exports = {};
$fcd9e4d86a0277eaf944ca3546ee7$exports = JSON.parse("{\"Empty\":\"空白\"}"); // @ts-ignore

var $c1af8e5962e38e4cf122539ddeaf$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersEsmInteropRequireDefault($fbc9e9d7cb7b3e7c701c779ec38417cd$exports).default,
  "bg-BG": _babelRuntimeHelpersEsmInteropRequireDefault($cb592d229837e637f9593ff7c701689$exports).default,
  "cs-CZ": _babelRuntimeHelpersEsmInteropRequireDefault($f17666a495bf7495c6bff6a1397e6822$exports).default,
  "da-DK": _babelRuntimeHelpersEsmInteropRequireDefault($e194eb80ef0031d8117819166a22680$exports).default,
  "de-DE": _babelRuntimeHelpersEsmInteropRequireDefault($c40bcdf693a8ed8a2291ef8d7b$exports).default,
  "el-GR": _babelRuntimeHelpersEsmInteropRequireDefault($ac454f31f410e77efbde3e1e4851cedb$exports).default,
  "en-US": _babelRuntimeHelpersEsmInteropRequireDefault($ed19cb0446558aab98a9086a697ac7$exports).default,
  "es-ES": _babelRuntimeHelpersEsmInteropRequireDefault($dc8cdf38b1ab312b8e3dd3e35ac00a29$exports).default,
  "et-EE": _babelRuntimeHelpersEsmInteropRequireDefault($a694686b3766c14509e50fe827e0f2b$exports).default,
  "fi-FI": _babelRuntimeHelpersEsmInteropRequireDefault($cb67d619f35171d4f8c8e2fc148491$exports).default,
  "fr-FR": _babelRuntimeHelpersEsmInteropRequireDefault($af684764dbb48d4f24251e7a5c48530$exports).default,
  "he-IL": _babelRuntimeHelpersEsmInteropRequireDefault($d69024b42a69f97c46c58a953f67e84f$exports).default,
  "hr-HR": _babelRuntimeHelpersEsmInteropRequireDefault($e6b7076edc78920211046f3c983cfbdb$exports).default,
  "hu-HU": _babelRuntimeHelpersEsmInteropRequireDefault($db974e9c56980ee80c35253d2f136aee$exports).default,
  "it-IT": _babelRuntimeHelpersEsmInteropRequireDefault($b9ca32da5122499256c996b9183ca3d$exports).default,
  "ja-JP": _babelRuntimeHelpersEsmInteropRequireDefault($d93cbf7ca50d42ab95c8247bd7$exports).default,
  "ko-KR": _babelRuntimeHelpersEsmInteropRequireDefault($e4194ee149df1a8d2d78edc886ab7fd$exports).default,
  "lt-LT": _babelRuntimeHelpersEsmInteropRequireDefault($e084f50698524d1617f726c5c5229$exports).default,
  "lv-LV": _babelRuntimeHelpersEsmInteropRequireDefault($d6d90ca120aa4d5001ed49fd45b8$exports).default,
  "nb-NO": _babelRuntimeHelpersEsmInteropRequireDefault($a3b3b03e00a7f050d1866c8c67b7f18c$exports).default,
  "nl-NL": _babelRuntimeHelpersEsmInteropRequireDefault($b87ad28933ffd5d3c721324feb$exports).default,
  "pl-PL": _babelRuntimeHelpersEsmInteropRequireDefault($f5481a4fa637113043217da5a6260$exports).default,
  "pt-BR": _babelRuntimeHelpersEsmInteropRequireDefault($fd14df6b825e4a9565037f1ca1aa0f0$exports).default,
  "pt-PT": _babelRuntimeHelpersEsmInteropRequireDefault($c82d4c61928ba408ae61ffae1197cc$exports).default,
  "ro-RO": _babelRuntimeHelpersEsmInteropRequireDefault($f83fdc6074b3422b785a49bb04be8fd$exports).default,
  "ru-RU": _babelRuntimeHelpersEsmInteropRequireDefault($c0d7db44cf5646c580ef6639717353$exports).default,
  "sk-SK": _babelRuntimeHelpersEsmInteropRequireDefault($a780415d2ea29cc31052caf8538da8$exports).default,
  "sl-SI": _babelRuntimeHelpersEsmInteropRequireDefault($fb01b3dc59b99eb11848f254d$exports).default,
  "sr-SP": _babelRuntimeHelpersEsmInteropRequireDefault($e08a3987f61a6b3d12b3e19ec5fd9$exports).default,
  "sv-SE": _babelRuntimeHelpersEsmInteropRequireDefault($b3a7572915c12bdc376a15c698e26a$exports).default,
  "tr-TR": _babelRuntimeHelpersEsmInteropRequireDefault($fffe30e4880b8ca2a1bf8bd52f099e3$exports).default,
  "uk-UA": _babelRuntimeHelpersEsmInteropRequireDefault($daa0babda3d97bfdac06e14540e3d556$exports).default,
  "zh-CN": _babelRuntimeHelpersEsmInteropRequireDefault($b9d579215c0cc839bfce28a9cec$exports).default,
  "zh-TW": _babelRuntimeHelpersEsmInteropRequireDefault($fcd9e4d86a0277eaf944ca3546ee7$exports).default
};
export function useSpinButton(props) {
  var _async = useRef();

  var value = props.value,
      textValue = props.textValue,
      minValue = props.minValue,
      maxValue = props.maxValue,
      isDisabled = props.isDisabled,
      isReadOnly = props.isReadOnly,
      isRequired = props.isRequired,
      onIncrement = props.onIncrement,
      onIncrementPage = props.onIncrementPage,
      onDecrement = props.onDecrement,
      onDecrementPage = props.onDecrementPage,
      onDecrementToMin = props.onDecrementToMin,
      onIncrementToMax = props.onIncrementToMax;
  var formatMessage = useMessageFormatter($c1af8e5962e38e4cf122539ddeaf$var$intlMessages);

  var clearAsync = function clearAsync() {
    return clearTimeout(_async.current);
  }; // eslint-disable-next-line arrow-body-style


  useEffect(function () {
    return function () {
      return clearAsync();
    };
  }, []);

  var onKeyDown = function onKeyDown(e) {
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || isReadOnly) {
      return;
    }

    switch (e.key) {
      case 'PageUp':
        if (onIncrementPage) {
          e.preventDefault();
          onIncrementPage();
          break;
        }

      // fallthrough!

      case 'ArrowUp':
      case 'Up':
        if (onIncrement) {
          e.preventDefault();
          onIncrement();
        }

        break;

      case 'PageDown':
        if (onDecrementPage) {
          e.preventDefault();
          onDecrementPage();
          break;
        }

      // fallthrough

      case 'ArrowDown':
      case 'Down':
        if (onDecrement) {
          e.preventDefault();
          onDecrement();
        }

        break;

      case 'Home':
        if (onDecrementToMin) {
          e.preventDefault();
          onDecrementToMin();
        }

        break;

      case 'End':
        if (onIncrementToMax) {
          e.preventDefault();
          onIncrementToMax();
        }

        break;
    }
  };

  var isFocused = useRef(false);

  var onFocus = function onFocus() {
    isFocused.current = true;
  };

  var onBlur = function onBlur() {
    isFocused.current = false;
  }; // Replace Unicode hyphen-minus (U+002D) with minus sign (U+2212).
  // This ensures that macOS VoiceOver announces it as "minus" even with other characters between the minus sign
  // and the number (e.g. currency symbol). Otherwise it announces nothing because it assumes the character is a hyphen.
  // In addition, replace the empty string with the word "Empty" so that iOS VoiceOver does not read "50%" for an empty field.


  textValue = textValue === '' ? formatMessage('Empty') : (textValue || "" + value).replace('-', "\u2212");
  useEffect(function () {
    if (isFocused.current) {
      announce(textValue, 'assertive');
    }
  }, [textValue]);
  var onIncrementPressStart = useCallback(function (initialStepDelay) {
    clearAsync();
    onIncrement(); // Start spinning after initial delay

    _async.current = window.setTimeout(function () {
      if (isNaN(maxValue) || isNaN(value) || value < maxValue) {
        onIncrementPressStart(60);
      }
    }, initialStepDelay);
  }, [onIncrement, maxValue, value]);
  var onDecrementPressStart = useCallback(function (initialStepDelay) {
    clearAsync();
    onDecrement(); // Start spinning after initial delay

    _async.current = window.setTimeout(function () {
      if (isNaN(minValue) || isNaN(value) || value > minValue) {
        onDecrementPressStart(60);
      }
    }, initialStepDelay);
  }, [onDecrement, minValue, value]);
  return {
    spinButtonProps: {
      role: 'spinbutton',
      'aria-valuenow': !isNaN(value) ? value : null,
      'aria-valuetext': textValue,
      'aria-valuemin': minValue,
      'aria-valuemax': maxValue,
      'aria-disabled': isDisabled || null,
      'aria-readonly': isReadOnly || null,
      'aria-required': isRequired || null,
      onKeyDown: onKeyDown,
      onFocus: onFocus,
      onBlur: onBlur
    },
    incrementButtonProps: {
      onPressStart: function onPressStart() {
        return onIncrementPressStart(400);
      },
      onPressEnd: clearAsync,
      onFocus: onFocus,
      onBlur: onBlur
    },
    decrementButtonProps: {
      onPressStart: function onPressStart() {
        return onDecrementPressStart(400);
      },
      onPressEnd: clearAsync,
      onFocus: onFocus,
      onBlur: onBlur
    }
  };
}